import { feedAppSelector, createRegularPostSelector } from 'selectors/feedSelectors'
import { createSelector } from 'reselect'
import { FEED_OWN_POST_COMPOSE_ID } from 'constants/feed'
import { State } from 'interfaces/state'
import { ComposeId, ComposeState } from 'interfaces/feed'
import { userImagesCollectionSelector, userImagesByIds } from 'selectors/userImagesSelectors'

export const composeIdSelector = (_state: State, props: { composeId: ComposeId }) => props.composeId

export const createComposeSelector = () => {
  return createSelector(
    feedAppSelector,
    composeIdSelector,
    ({ composes }, composeId): ComposeState | null => composes.byKey[composeId] || null
  )
}

export const createComposePostAuthorUidSelector = () => {
  const postSelector = createRegularPostSelector()

  const composePostUidSelector = createSelector(
    createComposeSelector(),
    (composeState) => composeState ? composeState.postUid : null
  )

  const composePostSelector = createSelector(
    (state) => state as State,
    composePostUidSelector,
    (state, postUid) => postUid ? postSelector(state, { postUid }) : null
  )

  return createSelector(
    composePostSelector,
    (post) => post ? post.authorUid : null
  )
}

export const composeSelector = createComposeSelector()

export const createComposeStateCreatedSelector = () => createSelector(
  createComposeSelector(),
  (composeState) => !!composeState
)

export const createComposePostUidSelector = () => createSelector(
  createComposeSelector(),
  (composeState) => composeState ? composeState.postUid || null : null
)

export const createComposeExecCommandSelector = () => createSelector(
  createComposeSelector(),
  (composeState) => composeState ? composeState.execCommand : null
)

export const createComposeLinkSelector = () => createSelector(
  createComposeSelector(),
  (composeState) => composeState && !composeState.isLinkRemoved ? composeState.link : null
)

export const isComposeExistsSelector = createSelector(
  createComposeSelector(),
  (composeState) => Boolean(composeState && composeState.isExists)
)

export const newPostComposeSelector = createSelector(
  feedAppSelector,
  ({ composes }) => composes.byKey[FEED_OWN_POST_COMPOSE_ID]
)

export const composeImagesIdsSelector = createSelector(
  composeSelector,
  (compose) => {
    if (!compose) {
      return { ids: [] }
    }
    return { ids: compose.imagesIds }
  }
)

export const createComposeImagesSelector = () => createSelector(
  userImagesCollectionSelector,
  composeImagesIdsSelector,
  userImagesByIds,
)

// deprecated, use createComposeImagesSelector
export const composeImagesSelector = createComposeImagesSelector()

export const composeHasContentCombiner = (hasText: boolean, hasImages: boolean, hasLink: boolean) => hasText || hasImages || hasLink

export const createComposeHasContentSelector = () => {

  const composeHasTextSelector = createSelector(
    composeSelector,
    (compose) => Boolean(compose && compose.text)
  )

  const composeHasImagesSelector = createSelector(
    composeSelector,
    (compose) => Boolean(compose && compose.imagesIds.length)
  )

  const composeLinkSelector = createSelector(
    createComposeLinkSelector(),
    (link) => !!link
  )

  return createSelector(
    composeHasTextSelector,
    composeHasImagesSelector,
    composeLinkSelector,
    composeHasContentCombiner
  )
}


export const createComposeExpandedPartSelector = () => {
  const composeHasFocusSelector = createSelector(
    composeSelector,
    (compose) => Boolean(compose && compose.isFocused)
  )

  const composeHasContentSelector = createComposeHasContentSelector()

  return createSelector(
    composeHasFocusSelector,
    composeHasContentSelector,
    (isFocused, hasContent) => isFocused || hasContent
  )
}

